import CostDiagram from './CostDiagram'
export default CostDiagram
